import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { PortalGlobals } from '../../../portalglobals'
import { ActivatedRoute, Router } from '@angular/router'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { UserDataService } from '../../../user-management/gateways/user-data-service'
@Component({
    selector: 'external-enrollment-landing',
    templateUrl: './External-Enrollment-Landing.html'
})

export class ExternalEnrollmentLanding implements OnInit {

    public userName: string
    public planyear: number
    accesskey: string
    enrollmentId: string
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    insCo :string
    constructor(private _router: Router, private _global: PortalGlobals,
        public _enrollementGateway: EnrollmentGateway, private route: ActivatedRoute, private _currentUserGateway: CurrentUserGateway, private userdataservice: UserDataService) {

    }
    ngOnInit() {
        
        if (this._global.currentUser === undefined || this._global.currentUser.insuranceCompanyId === undefined || this._global.currentUser.insuranceCompanyId === null) {
            this._currentUserGateway.getCurrentUser()
                .subscribe(user => {
                    if (user != null) {
                        this._global.currentUser = user
                        this.insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
                        if (this._global.selectedPlanYear === 0) {
                            this.userdataservice.currentYear.subscribe(
                                data => {
                                    this._global.selectedPlanYear = data
                                    this.setPageData()
                                }
                            )
                        }
                        else {
                            this.setPageData()
                        }
                    }
                })
        } else {
            this.insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this.setPageData() 
        }
      
    }

    setPageData() {
        this.userName = this._global.currentUser.firstName + ' ' + this._global.currentUser.lastName + ' ('+ this._global.currentUser.userProfileName+')'
        this.planyear = this._global.selectedPlanYear
        this.route
            .params
            .subscribe(params => {
                if (params['ak'] !== undefined && params['eid'] !== undefined) {
                    this.accesskey = String(params['ak'])
                    this.enrollmentId = String(params['eid'])
                }

            })
    }

    eappClick() {
        this._router.navigate(['/' + this.insCo + '/enrollment/e-app-external/' + this.accesskey + '/' + this.enrollmentId])
    } 
    dataEntryClick() {
        this._router.navigate(['/' + this.insCo + '/enrollment/external-agent/Step1/' + this.accesskey + '/' + this.enrollmentId + '/external'])
    }
    homeClick() {
        // to show menu on home page.
        window.open('../ep-ui/#/' + this.insCo + '/home')
        //this._router.navigate(['home'])
    }
    callScriptClick() {
        this._router.navigate(['/' + this.insCo + '/enrollment/phone-enrollment/ext/Step1/' + this.accesskey + '/' + this.enrollmentId])
    }
    esoaClick() {
        this._router.navigate(['/' + this.insCo + '/electronic-soa/submitsoa-external/' + this.accesskey + '/' + this.enrollmentId])
    }
}
